(() => {
  const sizeMatrixEl = document.querySelector('.size-matrix');
  if (!sizeMatrixEl) return;

  const sizeMatrixBtn = document.getElementById('size-matrix-add');
  if (!sizeMatrixBtn) {
    console.warn('Size Matrix Button not found!');
    return;
  }

  const cartType = sizeMatrixBtn.getAttribute('cartType');

  function updateSizeMatrixButton() {
    let total = 0;
    sizeMatrixEl.querySelectorAll('.size-matrix__card').forEach((card) => {
      total += parseInt(card.querySelector('.size-matrix__count').textContent) || 0;
    });

    sizeMatrixBtn.disabled = total === 0;
    const btnText = sizeMatrixBtn.querySelector('span');

    if (total > 0) {
      btnText.textContent = total === 1 ? 'Add 1 item to cart' : `Add ${total} items to cart`;
    } else {
      btnText.textContent = 'Add to cart';
    }
  }

  sizeMatrixEl.addEventListener('click', (event) => {
    const trigger = event.target.closest('.quantity__button');
    if (!trigger || trigger.disabled) return;

    const card = trigger.closest('.size-matrix__card');
    if (!card) return;

    const qtyEl = card.querySelector('.size-matrix__count');
    let qty = parseInt(qtyEl.textContent) || 0;
    const max = parseInt(card.dataset.max) || 9999;

    if (trigger.dataset.action === 'plus') {
      if (qty < max) qty++;
    } else if (trigger.dataset.action === 'minus') {
      qty = Math.max(qty - 1, 0);
    }

    qtyEl.textContent = qty;
    card.classList.toggle('active', qty > 0);
    updateSizeMatrixButton();
  });

  sizeMatrixEl.querySelectorAll('.size-matrix__card').forEach((card) => {
    card.addEventListener('click', (event) => {
      if (event.target.closest('.quantity__button') || card.classList.contains('size-matrix__card--disabled')) return;

      const qtyEl = card.querySelector('.size-matrix__count');
      let qty = parseInt(qtyEl.textContent) || 0;
      const max = parseInt(card.dataset.max) || 9999;

      if (qty === 0 && max > 0) {
        qtyEl.textContent = 1;
        card.classList.add('active');
        updateSizeMatrixButton();
      }
    });
  });

  sizeMatrixBtn.addEventListener('click', async () => {
    const items = [];

    sizeMatrixEl.querySelectorAll('.size-matrix__card').forEach((card) => {
      let qty = parseInt(card.querySelector('.size-matrix__count').textContent) || 0;
      const max = parseInt(card.dataset.max) || 9999;
      qty = Math.min(qty, max);

      if (qty > 0) {
        items.push({
          id: Number(card.dataset.variantId),
          quantity: qty,
        });
      }
    });

    if (!items.length) return;

    sizeMatrixBtn.disabled = true;
    sizeMatrixBtn.classList.add('loading');
    const btnText = sizeMatrixBtn.querySelector('span');
    btnText.textContent = 'Adding...';

    try {
      const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      const addData = await addResponse.json();

      if (!addResponse.ok) {
        throw new Error(addData.description || 'Something went wrong');
      }

      const cartData = await fetch(`${window.Shopify.routes.root}cart.js`).then((r) => r.json());

      document.querySelectorAll('.cart-count-bubble').forEach((el) => {
        const countEl = el.querySelector('span[aria-hidden]');
        if (countEl) countEl.textContent = cartData.item_count;
      });

      if (cartType === 'page') {
        window.location.href = '/cart';
        return;

      } else if (cartType === 'drawer') {
        fetch(`${routes.cart_url}?sections=cart-drawer`)
          .then((response) => response.json())
          .then((sections) => {
            const sectionIds = ['cart-drawer'];
            for (const sectionId of sectionIds) {
              const htmlString = sections[sectionId];
              const html = new DOMParser().parseFromString(htmlString, 'text/html');
              const sourceElement = html.querySelector(`${sectionId}`);
              const targetElement = document.querySelector(`${sectionId}`);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
            document.body.classList.add('overflow-hidden');
            const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
            theme_cart.classList.add('active');
          })
          .catch((e) => {
            console.error('Error updating cart sections:', e);
          });

      } else if (cartType === 'notification') {
        const cartNotification = document.querySelector('cart-notification');
        if (cartNotification) {
          try {
            const addedItem = addData.items[0];
            const itemKey = addedItem.key;

            const sectionsRes = await fetch(
              `${window.Shopify.routes.root}?sections=cart-notification-product,cart-notification-button,cart-icon-bubble`
            );
            const sections = await sectionsRes.json();

            cartNotification.renderContents({
              key: itemKey,
              sections: {
                'cart-notification-product': sections['cart-notification-product'],
                'cart-notification-button':  sections['cart-notification-button'],
                'cart-icon-bubble':          sections['cart-icon-bubble'],
              },
            });
          } catch (e) {
            console.error('Notification render failed:', e);
          }
        }
      }

      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));

      sizeMatrixEl.querySelectorAll('.size-matrix__count').forEach((el) => (el.textContent = '0'));
      sizeMatrixEl.querySelectorAll('.size-matrix__card').forEach((card) => card.classList.remove('active'));

      btnText.textContent = 'Added to cart';
      setTimeout(() => updateSizeMatrixButton(), 2000);

    } catch (error) {
      console.error(error);
      btnText.textContent = error.message || 'Error';
      setTimeout(() => updateSizeMatrixButton(), 2500);
    } finally {
      sizeMatrixBtn.classList.remove('loading');
      setTimeout(() => {
        sizeMatrixBtn.disabled = false;
      }, 300);
    }
  });

  updateSizeMatrixButton();
})();